import { defineStore } from "pinia"

export default defineStore("viewStore", {
  state: () => ({
    anonymize: false,
  }),
})
